import { ExtractedOrderData, extractOrderDataFromMessage } from './funzingDataExtractor';
import { extractOrderDataFromBasalon } from './basalonDataExtractor';
import { extractOrderDataFromLeap } from './leapDataExtractor';

const extractors = [extractOrderDataFromMessage, extractOrderDataFromBasalon, extractOrderDataFromLeap];

function hasData(data: ExtractedOrderData): boolean {
  return !!(data.firstName || data.lastName || data.date || data.time);
}

export function extractFromAnyMessage(text: string): ExtractedOrderData {
  for (const extractor of extractors) {
    const data = extractor(text);
    if (hasData(data)) return data;
  }
  return { firstName: null, lastName: null, date: null, time: null, persons: null, phone: null, source: null };
}
